import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetData } from '../selectors/dataSelector'

import Immutable from 'seamless-immutable'
import theme from './theme'

import NestedPieChart from './NestedPieChart'

const classes = ['Class 1', 'Class 2', 'Class 3', 'Class 4']

const styles = theme => ({})

class InfrastructureBufferChart extends PureComponent {
  render () {
    const { data, dataOuter } = this.props

    if (!arrayIsNotEmpty(data)) {
      return null
    }
    const width = 300
    const height = 300

    return (
      <NestedPieChart
        width={width}
        height={height}
        data={data}
        dataOuter={dataOuter}
        dataInner={data}
        categories={{ x: classes }}
        theme={theme}
      />
    )
  }
}

const transform = data => {
  const reducedData = data.reduce((object, item) => {
    const key =
      item.RESIDENTIAL_COUNT <= 11
        ? classes[0]
        : item.RESIDENTIAL_COUNT <= 26
          ? classes[1]
          : item.RESIDENTIAL_COUNT <= 45 ? classes[2] : classes[3]
    const prevCount = object[key]
    object[key] = prevCount ? prevCount + 1 : 1

    return object
  }, {})
  const arrayData = Object.keys(reducedData).map(key => ({
    x: key,
    y: reducedData[key]
  }))
  return Immutable(arrayData.sort((a, b) => a.x.localeCompare(b.x)))
}

const transformOuter = data => {
  const reducedData = data.reduce((object, item) => {
    const key = item.RESIDENTIAL_COUNT <= 11 ? 'misclassified' : 'correct'
    const prevCount = object[key]
    object[key] = prevCount ? prevCount + 1 : 1

    return object
  }, {})
  const arrayData = Object.keys(reducedData).map(key => ({
    x: key,
    y: reducedData[key]
  }))

  return Immutable(arrayData.sort((a, b) => a.x.localeCompare(b.x)))
}

const makeMapStateToProps = () => {
  const getData = makeGetData()
  const getDataOuter = makeGetData()
  const mapStateToProps = state => {
    return {
      data: getData(state, 'InfrastructurePipeline', transform),
      dataOuter: getDataOuter(state, 'InfrastructurePipeline', transformOuter)
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(
  withStyles(styles)(InfrastructureBufferChart)
)



// WEBPACK FOOTER //
// ./src/charts/InfrastructurePieChart.js